import React from 'react';
import { Container } from 'react-bootstrap';
import './Privacy.scss';

const Privacy: React.FC = () => {
  return (
    <div className="privacy-container">
      <Container>
        <h1 className="privacy-title">Política de Privacidad</h1>
        <p className="privacy-intro">
          Tu privacidad es importante para nosotros. Esta Política de Privacidad explica cómo recopilamos, usamos y protegemos tu información personal cuando utilizas nuestros servicios.
        </p>

        <div className="privacy-section">
          <h2>1. Información que Recopilamos</h2>
          <p>
            Podemos recopilar los siguientes tipos de información:
          </p>
          <ul>
            <li>Detalles personales, como tu nombre y dirección de correo electrónico.</li>
            <li>Información de pago para transacciones.</li>
            <li>Datos de uso, incluidos direcciones IP y actividad de navegación.</li>
          </ul>
        </div>

        <div className="privacy-section">
          <h2>2. Cómo Usamos tu Información</h2>
          <p>
            Usamos tu información para:
          </p>
          <ul>
            <li>Proveer y mejorar nuestros servicios.</li>
            <li>Procesar pagos y transacciones.</li>
            <li>Comunicarnos contigo sobre actualizaciones y ofertas.</li>
          </ul>
        </div>

        <div className="privacy-section">
          <h2>3. Compartir tu Información</h2>
          <p>
            No vendemos ni alquilamos tu información personal. Podemos compartir tu información con terceros solo cuando sea necesario, como para procesar pagos o cumplir con obligaciones legales.
          </p>
        </div>

        <div className="privacy-section">
          <h2>4. Seguridad de tu Información</h2>
          <p>
            Tomamos medidas razonables para proteger tu información personal contra accesos no autorizados, divulgación o uso indebido.
          </p>
        </div>

        <div className="privacy-section">
          <h2>5. Tus Derechos</h2>
          <p>
            Tienes derecho a:
          </p>
          <ul>
            <li>Acceder a los datos personales que tenemos sobre ti.</li>
            <li>Solicitar correcciones a tu información personal.</li>
            <li>Solicitar la eliminación de tus datos cuando corresponda.</li>
          </ul>
        </div>

        <div className="privacy-section">
          <h2>6. Cambios a Esta Política</h2>
          <p>
            Podemos actualizar esta Política de Privacidad de vez en cuando. Cualquier cambio será publicado en esta página con la fecha actualizada.
          </p>
        </div>

        <div className="privacy-section">
          <h2>7. Contáctanos</h2>
          <p>
            Si tienes alguna pregunta o inquietud sobre esta Política de Privacidad, por favor contáctanos en <a href="mailto:soporte@codetrend.net">soporte@codetrend.net</a>.
          </p>
        </div>
      </Container>
    </div>
  );
};

export default Privacy;